import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'

const IconHeading = ({ icon, title, number, className }) => {
  return (
    <div className="flex items-center">
      <Icon icon={icon} className="global-icon" />
      <h1 className={className}>
        {title}
        {number && <span> ({number})</span>}
      </h1>
    </div>
  )
}

IconHeading.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default IconHeading
